import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { CustomFontAwesomeIconProps } from './types/custom-font-awesome-icon.props';

/**
 * Bookmark icon — used by the saved-filters trigger and menu.
 */
export const Bookmark = (props: CustomFontAwesomeIconProps) => {
  return (
    <FontAwesomeIcon
      icon={['fass', 'bookmark']}
      {...props}
    />
  );
};
